"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Gets the sort value from URL query params. SSR-safe.
 */
var getSortFromUrl = function getSortFromUrl() {
  if (typeof window === 'undefined') return null;
  var queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('sort');
};
/**
 * Builds href preserving existing query params and updating sort.
 * SSR-safe - falls back to simple query string.
 */


var buildSortHref = function buildSortHref(sortType) {
  if (typeof window === 'undefined') return "?sort=".concat(sortType);
  var url = new URL(window.location.href);
  url.searchParams.set('sort', sortType); // Use absolute URL so that resolveUrl() (injected by babel-plugin-absolute-urls) skips prefixing

  return "".concat(url.origin).concat(url.pathname).concat(url.search);
};
/**
 * Updates URL with new sort param without page reload.
 * Uses history.pushState for SPA-style navigation.
 */


var updateUrlWithSort = function updateUrlWithSort(sortType) {
  if (typeof window === 'undefined') return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort', sortType);
  window.history.pushState({}, '', url.toString());
};
/**
 * Gets the selected sort option label based on state or URL.
 */


var getSelectedSortOptionLabel = function getSelectedSortOptionLabel(sortOptions, selectedSort) {
  var _sortOptions$0$sortLa, _sortOptions$;

  var sortValue = selectedSort !== null && selectedSort !== void 0 ? selectedSort : getSortFromUrl();

  if (sortValue) {
    var found = sortOptions.find(function (option) {
      return option.sortType === sortValue;
    });
    if (found) return found.sortLabel;
  }

  return (_sortOptions$0$sortLa = (_sortOptions$ = sortOptions[0]) === null || _sortOptions$ === void 0 ? void 0 : _sortOptions$.sortLabel) !== null && _sortOptions$0$sortLa !== void 0 ? _sortOptions$0$sortLa : '';
};
/**
 * SortingDropdown - Pure UI component for sorting dropdown
 *
 * Supports both SSR and CSR modes:
 * - SSR Mode (no onSortChange): Uses standard <a href> navigation
 * - CSR Mode (with onSortChange): Prevents navigation, updates URL via pushState, calls callback
 *
 * Features:
 * - Preserves existing query parameters when building URLs
 * - Updates URL without page reload in CSR mode
 * - Initializes from URL on mount (SSR→CSR hydration)
 * - Self-contained state management
 * - Full keyboard accessibility
 *
 * @example
 * // SSR mode (from Twig):
 * <SortingDropdown sortOptions={options} />
 *
 * @example
 * // CSR mode (from React component):
 * <SortingDropdown
 *   sortOptions={options}
 *   onSortChange={(sortType) => fetchTopics({ sort: sortType })}
 * />
 */


var SortingDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SortingDropdown, _Component);

  var _super = _createSuper(SortingDropdown);

  function SortingDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, SortingDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false,
      selectedSort: typeof window !== 'undefined' ? getSortFromUrl() : null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSortChange", function (e, sortType) {
      var onSortChange = _this.props.onSortChange;

      if (onSortChange) {
        // CSR Mode: Prevent navigation, update URL and state, notify parent
        e.preventDefault();

        _this.setState({
          selectedSort: sortType
        });

        updateUrlWithSort(sortType);
        onSortChange(sortType);
      } // SSR Mode: Let the <a href> navigate naturally

    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggle", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isOpen: !prevState.isOpen
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.handleToggle();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SortingDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var sortOptions = this.props.sortOptions;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          selectedSort = _this$state.selectedSort;
      var selectedSortOptionLabel = getSelectedSortOptionLabel(sortOptions, selectedSort);
      return (0, _preact.h)("nav", null, (0, _preact.h)(_dropdown.default, {
        popupName: "sorting-dropdown",
        className: "dropdown dropdown--sort-options",
        closeOnDropdownClick: true,
        triggerClass: "dropdown--sort-options-trigger",
        trigger: (0, _preact.h)("p", {
          className: (0, _classnames.default)('sort-option-trigger', 'dropdown-links', {
            open: isOpen
          }),
          onClick: this.handleToggle,
          onKeyDown: this.handleKeyDown
        }, (0, _preact.h)("span", null, selectedSortOptionLabel))
      }, sortOptions.filter(function (option) {
        return option.sortLabel !== selectedSortOptionLabel;
      }).map(function (option) {
        return (0, _preact.h)("a", {
          key: option.sortType,
          className: "dropdown-links__item-link",
          href: (0, _absoluteUrlRuntime.resolveUrl)(buildSortHref(option.sortType)),
          onClick: function onClick(e) {
            return _this2.handleSortChange(e, option.sortType);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter') _this2.handleSortChange(e, option.sortType);
          }
        }, option.sortLabel);
      })));
    }
  }]);
  return SortingDropdown;
}(_preact.Component);

var _default = SortingDropdown;
exports.default = _default;